export default __webpack_public_path__ + "static/media/qlik.favicon.8681852f.ico";